import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-authenticators', {
        url: '/shared-authenticators',
        component: 'companySharingCenterSharedAuthenticators',
        resolve: {companyId, allAccounts, accounts},
    });
}

/** @ngInject */
function allAccounts(companyId, SharedAccountsService) {
    return SharedAccountsService
        .getAllByCompany({companyId}, {});
}

/** @ngInject */
function accounts($filter, allAccounts) {
    return allAccounts.$promise
        .then(items => items.filter(item => item.enabled2fa))
        .then(items => $filter('orderBy')(items, 'publicService.serviceName'))
        .then(items => items.map((account) => ({...account, serviceDisplayName: serviceDisplayName(account)})))
}

function serviceDisplayName(account) {
    let displayName = '';
    if (account.publicService.slug != 'other' || !account.customServiceName) {
        displayName = account.publicService.serviceName;
    } else if (account.publicService.slug == 'other'){
        displayName = account.customServiceName;
    }
    return displayName;
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/shared-authenticators.state.js